module.exports = __webpack_public_path__ + "images/bind_img.1753928438511.png";